export const PLATFORM_LINKS = {
    discord: "https://discord.com/oauth2/authorize?client_id=1543619009126338710&permissions=125952&integration_type=0&scope=bot",
    telegram: "https://t.me/PTG_Tgram_bot"
  };
  